import { Link } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import PageHeader from "@/components/feature/PageHeader";
import Reveal from "@/components/feature/Reveal";

const benefits = [
  {
    icon: "ri-line-chart-line",
    title: "INCREMENTA TU PATRIMONIO",
    text: "La inversión inmobiliaria es una alternativa para construir patrimonio a largo plazo, protegiendo el valor de tu capital en activos reales.",
  },
  {
    icon: "ri-money-dollar-circle-line",
    title: "FLUJO DE ARRIENDO MENSUAL",
    text: "Destaca el potencial de generar ingresos mediante el arriendo de una propiedad, creando una fuente de renta recurrente.",
  },
  {
    icon: "ri-bank-line",
    title: "VENTAJA TRIBUTARIA DFL2",
    text: "Algunas propiedades cuentan con beneficios asociados al DFL2. Te recomendamos consultar los detalles y condiciones vigentes con tu asesor tributario.",
  },
  {
    icon: "ri-funds-line",
    title: "MAYOR PLUSVALÍA",
    text: "El potencial de valorización de una propiedad depende de su ubicación, desarrollo urbano y condiciones del mercado.",
  },
  {
    icon: "ri-shield-star-line",
    title: "PÓLIZA DE SEGURO DE GARANTÍA — VENTA EN VERDE",
    text: "SIN COSTO",
    highlight: true,
  },
  {
    icon: "ri-file-shield-2-line",
    title: "GASTOS NOTARIALES DE PROMESA",
    text: "SIN COSTO",
    highlight: true,
  },
];

export default function Inversion() {
  return (
    <Layout>
      <PageHeader
        eyebrow="Inversión"
        title="Invierte en proyectos pensados para crecer contigo"
        subtitle="Presentamos la inversión inmobiliaria como una alternativa sólida para construir patrimonio, generar renta y asegurar el futuro de tu familia."
      />

      <section className="px-4 md:px-8 lg:px-12 py-14 md:py-20">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <Reveal key={benefit.title} delay={index * 80}>
              <div
                className={`flex flex-col gap-4 rounded-lg border p-7 h-full hover:-translate-y-1.5 transition-transform duration-500 ${
                  benefit.highlight
                    ? "border-primary-200 bg-primary-50"
                    : "border-background-200/70 bg-background-50"
                }`}
              >
                <span className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-700">
                  <i className={`${benefit.icon} text-xl`} />
                </span>
                <h3 className="font-heading text-xl text-foreground-900 leading-snug">
                  {benefit.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{benefit.text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="px-4 md:px-8 lg:px-12 pb-20 md:pb-28">
        <Reveal className="max-w-3xl mx-auto flex flex-col gap-5 rounded-lg border border-background-200/70 bg-background-100/70 p-8">
          <p className="text-sm text-foreground-500 leading-relaxed">
            Nota: la información presentada tiene fines informativos y no constituye una promesa
            de rentabilidad ni asesoría financiera o tributaria. Las condiciones de financiamiento,
            beneficios tributarios y valorización dependen de cada proyecto y de la situación
            particular de cada inversionista. Te recomendamos siempre asesorarte con profesionales
            calificados.
          </p>
          <Link
            to="/contacto"
            className="inline-flex self-start items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 dark:text-foreground-950 text-sm font-semibold px-6 py-3 transition-colors duration-300 whitespace-nowrap"
          >
            HABLAR CON UN ASESOR
            <i className="ri-arrow-right-line" />
          </Link>
        </Reveal>
      </section>
    </Layout>
  );
}